import React, { useEffect, useState } from 'react';
import { Button, Collapse } from 'react-bootstrap';
import moment from 'moment';
import { setStepIndex } from '../../../redux/globalJoyrideSlice';
import { useDispatch } from 'react-redux';

const HolidayCategoryTabs = ({ categories, submittedHolidays = [], onBulkSubmit }) => {
  const [openCategories, setOpenCategories] = useState([]);
  const [selectedHolidays, setSelectedHolidays] = useState([]);
  const [editRows, setEditRows] = useState({});
  const [isValidEdit, setIsValidEdit] = useState(true);
  const [autoSelected, setAutoSelected] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("MASTER HOLIDAYS (categories):", categories);
  }, [categories]);
  useEffect(() => {
    console.log("SUBMITTED HOLIDAYS (from backend):", submittedHolidays);
  }, [submittedHolidays]);

  useEffect(() => {
    let allValid = true;
    for (const id in editRows) {
      const rowData = editRows[id];
      if (rowData?.start_date && rowData?.end_date) {
        const startDate = moment(rowData.start_date);
        const endDate = moment(rowData.end_date);
        if (startDate.isAfter(endDate)) {
          allValid = false;
          break;
        }
      }
    }
    setIsValidEdit(allValid);
  }, [editRows]);

  useEffect(() => {
    const submittedKeys = (submittedHolidays || []).map(h => {
      const name = ((h.details || h.name) || "").trim();
      const start = h.start_date ? moment(h.start_date).format("YYYY-MM-DD") : "";
      const end = h.end_date ? moment(h.end_date).format("YYYY-MM-DD") : "";
      return `${name}_${start}_${end}`;
    });
    setAutoSelected(submittedKeys);
  }, [submittedHolidays]);



  const toggleCheckbox = (holiday) => {
    const name = ((holiday.name || holiday.details) || "").trim();
    const start = holiday.start_date ? moment(holiday.start_date).format("YYYY-MM-DD") : "";
    const end = holiday.end_date ? moment(holiday.end_date).format("YYYY-MM-DD") : "";
    const sig = `${name}_${start}_${end}`;

    if (autoSelected.includes(sig)) {
      alert("This holiday is already added and cannot be changed.");
      return;
    }

    setSelectedHolidays((prev) => {
      const exists = prev.find((h) => h.id === holiday.id);
      return exists ? prev.filter((h) => h.id !== holiday.id) : [...prev, holiday];
    });

    dispatch(setStepIndex(3));
  };


  const toggleCategory = (categoryName) => {
    setOpenCategories((prev) =>
      prev.includes(categoryName)
        ? prev.filter((cat) => cat !== categoryName)
        : [...prev, categoryName]
    );
    setTimeout(() => {
      dispatch(setStepIndex(2));
    }, 300);
  };

  const updateField = (id, field, value) => {
    setEditRows((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  return (
    <div className="holiday-categories" data-tour="holiday-category-list">
      {Object.entries(categories || {}).map(([categoryName, holidays]) => (
        <div key={categoryName} className="mb-3">
          <Button
            variant="outline-primary"
            onClick={() => toggleCategory(categoryName)}
            aria-controls={`collapse-${categoryName}`}
            aria-expanded={openCategories.includes(categoryName)}
            className="w-100 text-start"
          >
            {categoryName.toUpperCase()} ({holidays?.length || 0})
          </Button>
          <div data-tour="holiday-select-checkbox"></div>
          <Collapse in={openCategories.includes(categoryName)}>

            {Array.isArray(holidays) && holidays.length > 0 ? (
              <div id={`collapse-${categoryName}`} className="mt-2">
                <div className="list-group">
                  {holidays.map((holiday) => {
                    const isSelected = selectedHolidays.some((h) => h.id === holiday.id);
                    const isEditing = !!editRows[holiday.id];
                    const rowData = isEditing ? editRows[holiday.id] : holiday;

                    const validStart =
                      holiday.start_date && holiday.start_date !== 'null';
                    const validEnd =
                      holiday.end_date && holiday.end_date !== 'null';

                    return (
                      <div key={holiday.id} className="list-group-item">
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            width: '100%',
                            marginBottom: 8,
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={
                                isSelected ||
                                autoSelected.includes(
                                  `${((holiday.name || holiday.details) || "").trim()}_${holiday.start_date ? moment(holiday.start_date).format("YYYY-MM-DD") : ""}_${holiday.end_date ? moment(holiday.end_date).format("YYYY-MM-DD") : ""}`
                                )
                              }
                              
                              onChange={() => toggleCheckbox(holiday)}
                              style={{ flexShrink: 0, margin: 0 }}
                            />

                            {/* Name + Date in one line */}
                            <div className="d-flex align-items-center" style={{ gap: '8px', flexWrap: 'nowrap' }}>
                              <strong style={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
                                {holiday.name || holiday.details}
                              </strong>

                              <span
                                className="rounded-pill px-2 py-1 text-white"
                                style={{
                                  fontSize: '0.9em',
                                  backgroundColor: '#0d6efd', // Bootstrap primary color
                                  whiteSpace: 'nowrap',
                                  flexShrink: 0,
                                }}
                              >
                                {validStart
                                  ? moment(holiday.start_date).format('MMM DD (ddd)')
                                  : 'Add date'}
                                {validEnd &&
                                  holiday.start_date !== holiday.end_date &&
                                  ` - ${moment(holiday.end_date).format('MMM DD (ddd)')}`}
                              </span>
                            </div>
                          </div>

                          <div style={{ marginLeft: 'auto', flex: '0 0 auto' }}>
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() =>
                                setEditRows((prev) =>
                                  prev[holiday.id]
                                    ? { ...prev, [holiday.id]: undefined }
                                    : { ...prev, [holiday.id]: holiday }
                                )
                              }
                            >
                              {isEditing ? 'Cancel' : 'Edit'}
                            </button>
                          </div>
                        </div>

                        {isEditing && (
                          <div className="row gx-2 gy-1">
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                value={rowData.name || rowData.details || ''}
                                onChange={(e) =>
                                  updateField(holiday.id, 'name', e.target.value)
                                }
                                placeholder="Name"
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="date"
                                className="form-control"
                                value={
                                  rowData.start_date
                                    ? moment(rowData.start_date).format('YYYY-MM-DD')
                                    : ''
                                }
                                onChange={(e) =>
                                  updateField(holiday.id, 'start_date', e.target.value)
                                }
                              />
                            </div>
                            <div className="col-md-3">
                              <input
                                type="date"
                                className="form-control"
                                value={
                                  rowData.end_date
                                    ? moment(rowData.end_date).format('YYYY-MM-DD')
                                    : ''
                                }
                                onChange={(e) =>
                                  updateField(holiday.id, 'end_date', e.target.value)
                                }
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="text-muted px-3 mt-2">No holidays in this category.</div>
            )}
        
          </Collapse>
        </div>
      ))}

{
  selectedHolidays.length > 0 && (
    <div className="mt-4 text-end">
      <button
        className="btn btn-success"
        data-tour="holiday-submit-button"
        onClick={() => {
          if (!isValidEdit) {
            alert(
              'Error: The start date cannot be after the end date. Please correct the dates before submitting.'
            );
            return;
          }
          const dataToSubmit = selectedHolidays
            .filter((holiday) => {
              const name = ((holiday.name || holiday.details) || "").trim();
              const start = holiday.start_date ? moment(holiday.start_date).format("YYYY-MM-DD") : "";
              const end = holiday.end_date ? moment(holiday.end_date).format("YYYY-MM-DD") : "";
              const sig = `${name}_${start}_${end}`;
              return !autoSelected.includes(sig); // keep only new ones
            })
            .map((holiday) =>
              editRows[holiday.id] ? { ...holiday, ...editRows[holiday.id] } : holiday
            );

          onBulkSubmit(dataToSubmit);
        }}
      >
        Submit Selected Holidays
      </button>
    </div>
  )
}
    </div >
  );
};

export default HolidayCategoryTabs;